import Vue from 'vue';
import { trim } from 'lodash';

const Linkify = {
  install(): void {
    Vue.prototype.linkify = (text: string): string => {
      if (!text || !trim(text)) {
        return '';
      }

      const regex = /(?:(?:https?|ftp|file):\/\/|www\.|ftp\.)(?:\([-A-Z0-9+&@#/%=~_|$?!:,.]*\)|[-A-Z0-9+&@#/%=~_|$?!:,.])*(?:\([-A-Z0-9+&@#/%=~_|$?!:,.]*\)|[A-Z0-9+&@#/%=~_|$])/igm;
      return text.replace(regex, (match: string) => {
        let url = match;
        if (match.startsWith('www')) {
          url = `//${match}`;
        }
        return `<a href="${url}" target="_blank">${match}</a>`;
      });
    };
  },
};

export default Linkify;
